import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_PRATICA_MATERIA } from '../../data.const';
import {
  setListConfigAction,
  setLoaders,
  setPopupInfo,
  storePraticaMateriaAction,
} from '../../data.action';
import { rootConfig } from '../../../../../config/root-config';

const retrievePraticaMateriaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_PRATICA_MATERIA),
    map(() => ({
      page: 1,
      pageSize: rootConfig.populateFields,
      order: [['nome', 'asc']],
    })),
    // tap(p => console.log(`[epic ${RETRIEVE_PRATICA_MATERIA}]`, p)),
    withLatestFrom(state$),
    switchMap(([body, _state]) => {
      return concat(
        of(setLoaders({ praticaLoader: true })),
        of(setListConfigAction({ role: body })),
        defer(() =>
          from(
            request({
              path: `praticaMateria/list`,
              method: httpMethods.POST,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return { total: p?.total, result: [...p?.result] };
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_PRATICA_MATERIA}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(data => of(storePraticaMateriaAction(data))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_PRATICA_MATERIA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ praticaLoader: false }))
      );
    })
  );

export default retrievePraticaMateriaEpic;
